import { IBoardInfo, IBoardInfoData } from "@/domain/entities/board";
import { IResultData } from "@/domain/entities/shared/result";
import TYPES from "@/ioc/identifiers";
import { container } from "@/ioc/inversify.config";
import { IBoardRepository } from "@/repositories/board/boardRepository.types";
import { defineStore } from "pinia";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";
import { ICustomCode } from "@/domain/entities/system/customCode.types";

const boardRepository = () => {
  return container.get<IBoardRepository>(TYPES.IBoardRepository);
};

interface IBoardState {
  boardInfos: IBoardInfoData[];
}

export const useBoardStore = defineStore("board", {
  state: (): IBoardState => {
    return {
      boardInfos: [],
    };
  },
  getters: {},
  actions: {
    /**
     * 유저의 탑승기록을 불러온다.
     * @param boardDtmFrom 탑승일자 검색범위 (from)
     * @param boardDtmTo 탑승일자 검색범위 (to)
     * @param sortOrder 탑승일자 정렬순서 (default : realOnDtm desc)
     */
    async getBoardingHistory(
      boardDtmFrom: string,
      boardDtmTo: string,
      sortOrder?: string
    ): Promise<IResultData<IBoardInfo[]>> {
      const boardInfoResult: IResultData<IBoardInfo[]> = {
        isSuccess: false,
      };

      await boardRepository()
        .getBoardingHistory(boardDtmFrom, boardDtmTo, sortOrder)
        .then((result) => {
          result
            .map((boardInfo) => {
              boardInfoResult.isSuccess = true;
              boardInfoResult.data = boardInfo;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(boardInfoResult, error);
              boardInfoResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          boardInfoResult.errorMessage = error.message;
        });
      this.boardInfos = boardInfoResult.data ?? [];

      return boardInfoResult;
    },

    async requestReport(
      boardUid: string,
      reportReason: ICustomCode
    ): Promise<IResultData<boolean>> {
      const reportResult: IResultData<boolean> = {
        isSuccess: false,
        data: false,
      };

      await boardRepository()
        .requestReport(boardUid, reportReason)
        .then((result) => {
          result
            .map((result) => {
              reportResult.isSuccess = result.isSuccess;
              reportResult.data = result.isSuccess;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(reportResult, error);
              reportResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          reportResult.errorMessage = error.message;
        });

      return reportResult;
    },

    async requestGetOffBus(
      boardUid: string,
      getOffBusStopId: string,
      getOffYn: boolean
    ): Promise<IResultData<boolean>> {
      const getOffBusResult: IResultData<boolean> = {
        isSuccess: false,
        data: false,
      };

      await boardRepository()
        .requestGetOffBus(boardUid, getOffBusStopId, getOffYn)
        .then((result) => {
          result
            .map((result) => {
              getOffBusResult.isSuccess = result.isSuccess;
              getOffBusResult.data = result.isSuccess;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(getOffBusResult, error);
              getOffBusResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          getOffBusResult.errorMessage = error.message;
        });

      return getOffBusResult;
    },
  },
});
